import React from 'react';
import {
  Container,
  Box,
  Typography,
  Link,
  Paper,
} from '@mui/material';
import {
  IconButton,
  Icon
} from '@mui/material';


export default function IENotSupported() {
  return (
    <Container>
      {/* title */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={6}
      >
        <Box>
          <IconButton style={{ pointerEvents: 'none' }} size="large"><Icon /></IconButton>
        </Box>
      </Box>
      <Paper style={{ padding: 32 }}>
        <Typography variant="h5" gutterBottom style={{ color: 'darkred', marginBottom: 24, fontWeight: 'bold' }}>
          PACKTRACK no longer supports Internet Explorer!
        </Typography>
        <Typography variant="subtitle1" gutterBottom style={{ marginBottom: 24 }}>
          Hello! You appear to be running the Internet Explorer browser. Unfortunately, this browser is getting really (really) old. It's also buggy, lacks critical functionality, has known security issues and isn't supported by Microsoft.
          It's no longer safe to run this browser and you should stop using it right away. For your browsing safety we highly recommend upgrading to any available modern browser
          including <Link href="https://www.google.com/chrome/" underline="hover">Google Chrome</Link>, <Link href="https://www.mozilla.org/firefox/" underline="hover">Mozilla Firefox</Link>, <Link href="https://www.microsoft.com/edge/" underline="hover">Microsoft Edge</Link> or <Link href="https://support.apple.com/downloads/safari" underline="hover">Safari</Link>.
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          We've supported Internet Explorer longer than many other online services but continuing to do so no longer makes sense.
          The PACKTRACK interface is undergoing an exciting transition this year with huge usability improvements and many exciting new features.
          Unfortunately, this new design requires a modern web browser and we have officially stopped supporting Internet Explorer.
          Your browser may continue to work for a few more weeks but will soon be unable to access PACKTRACK at all.
          If you're unable to upgrade your browser then please reach out using the <Link href="https://mypacktrack.com/support" underline="hover">Support</Link> page to let us know why and we'll see if we can help.
        </Typography>
      </Paper>
    </Container>
  );
}